export enum CreditCardRewardsType {
  CASH_BACK = "cash_back",
  GIFT_CARD = "gift_card",
  CHASE_ULTIMATE_REWARDS = "chase_ultimate_rewards",
  AMERICAN_EXPRESS_MEMBERSHIP_REWARDS = "american_express_membership_rewards",
  CITI_THANKYOU_POINTS = "citi_thankyou_points",
  CAPITAL_ONE_REWARDS = "capital_one_rewards",
  BILT_REWARDS = "bilt_rewards",
  WELLS_FARGO_REWARDS = "wells_fargo_rewards",
  BANK_OF_AMERICA_REWARDS = "bank_of_america_rewards",
  BARCLAYCARD_REWARDS = "barclaycard_rewards",
  BREX = "brex_points",
  US_BANK_REWARDS = "us_bank_rewards",
  UNITED = "united",
  STATUS_QUALIFYING_POINTS_UNITED = "status_qualifying_points_united",
  ALASKA = "alaska",
  AMERICAN = "american",
  SOUTHWEST = "southwest",
  JETBLUE = "jetblue",
  HAWAIIAN = "hawaiian",
  FRONTIER = "frontier",
  BREEZEPOINTS = "breezepoints",
  AIR_FRANCE_KLM_FLYING_BLUE = "air_france_klm_flying_blue",
  AVIOS = "avios",
  AIR_CANADA_AEROPLAN = "air_canada_aeroplan",
  DELTA = "delta",
  STATUS_QUALIFYING_POINTS_DELTA = "status_qualifying_points_delta",
  SPIRIT_AIRLINES = "spirit_airlines",
  ALL_NIPPON_AIRWAYS = "all_nippon_airways",
  AVIANCA = "avianca",
  CATHAY_PACIFIC = "cathay_pacific",
  EMIRATES = "emirates",
  KOREAN = "korean",
  LATAM = "latam",
  LUFTHANSA = "lufthansa",
  VIRGIN = "virgin",
  BEST_WESTERN = "best_western",
  CHOICE = "choice",
  HYATT = "hyatt",
  IHG = "ihg",
  WYNDHAM = "wyndham",
  MARRIOTT_BONVOY = "marriott_bonvoy",
  HILTON = "hilton",
  RADISSON = "radisson",
  CARNIVAL = "carnival",
  AMTRAK = "amtrak",
  PENFED = "penfed",
  NAVY_FEDERAL_REWARDS = "navy_federal_rewards",
  EXPEDIA = "expedia",
  NORWEGIAN_CRUISE_POINTS = "norwegian_cruise_points",
  MYCRUISE_POINTS = "mycruise_points",
  DISNEY_REWARDS_DOLLARS = "disney_rewards_dollars",
  FUNPOINTS = "funpoints",
  ALLWAYS_POINTS = "allways_points",
  CHOICE_PRIVILEGES = "choice_privileges_points",
  HSBC_REWARDS = "hsbc_rewards_points",
  GAME_PASS_ULTIMATE = "game_pass_ultimate",
  GM_REWARDS_POINTS = "gm_rewards_points",
  GM_BUSINESS_CARD_POINTS = "gm_business_card_points",
  RCI_REWARDS = "rci_rewards",
}
